import React from 'react'
import styled from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-top: 48px;
  margin-bottom: 32px;
`

const Item = styled.div`
  padding: 40px 0;
  background-color: #c7b9ff;
  display: flex;
  column-gap: 32px;
`

const Column = styled.div`
  width: 50%;
  text-align: center;
`

const Stat = styled.div`
  font-weight: 600;
  font-size: 88px;
  line-height: 88px;
  ${(p) => p.mobile && 'font-size: 44px; line-height: 44px;'}
`

const StatSubheading = styled.p`
  margin-top: 8px;
`

const Stats = () => {
  return (
    <>
      <Heading>Stats</Heading>
      <Subheading>Desktop</Subheading>
      <Item>
        <Column>
          <Stat>20,000</Stat>
          <StatSubheading>Sub heading</StatSubheading>
        </Column>
        <Column>
          <Stat>$1.2m</Stat>
          <StatSubheading>Sub heading</StatSubheading>
        </Column>
      </Item>
      <Subheading>Mobile</Subheading>
      <Item>
        <Column>
          <Stat mobile>20,000</Stat>
          <StatSubheading>Sub heading</StatSubheading>
        </Column>
        <Column>
          <Stat mobile>$1.2m</Stat>
          <StatSubheading>Sub heading</StatSubheading>
        </Column>
      </Item>
    </>
  )
}

export default Stats
